import { __assign, __rest } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import HiddenLayout from './HiddenLayout';
export var DefaultBlockedFullView = function (_a) {
    var deviation = _a.deviation, blockReason = _a.blockReason, _b = _a.i18nKey, i18nKey = _b === void 0 ? blockReason : _b, _c = _a.iconType, iconType = _c === void 0 ? 'blocked' : _c, props = __rest(_a, ["deviation", "blockReason", "i18nKey", "iconType"]);
    var t = useTranslation().t;
    return (React.createElement(HiddenLayout, __assign({ deviation: deviation, iconType: iconType, title: t([
            "deviationview.blocked." + i18nKey,
            'deviationview.blocked.default',
        ]), text: t("deviationview.blocked." + i18nKey + ".text", { defaultValue: null }) }, props)));
};
export default DefaultBlockedFullView;
//# sourceMappingURL=DefaultBlocked.js.map